import { render } from "./TvaSlider.vue?vue&type=template&id=5ba13628&scoped=true"
import script from "./TvaSlider.vue?vue&type=script&lang=js"
export * from "./TvaSlider.vue?vue&type=script&lang=js"

import "./TvaSlider.vue?vue&type=style&index=0&id=5ba13628&lang=scss&scoped=true"
import "./TvaSlider.vue?vue&type=style&index=1&id=5ba13628&lang=scss"

import exportComponent from "/Users/matteo.direnzo/Documents/TVA/eni-digit_eni-storia/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ba13628"]])

export default __exports__